/* eslint-disable @typescript-eslint/no-explicit-any */
import { Tab, Tabs } from "@mui/material";
import theme from "../../Theme/Theme";
import { Vocabulary } from "../../Utils/Vocabulary";
import Users from "./Users";
import { LocalUrlEnum } from "../../Utils/Utils";
import { usersTypes } from "../../Utils/Constants";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function UsersMainPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(0);

  useEffect(() => {
    const search: any = location.search.split("?");
    search.forEach((value: any) => {
      if (value !== "") {
        const params = value.split("&");
        const values = params[0].split("=");
        if (values[0] === "type") setValueFromLocation(values[1]);
      }
    });
  }, [location]);

  /**
   *
   * @param newValue
   */
  function setValueFromLocation(newValue: string) {
    switch (newValue) {
      case usersTypes.employees:
        setValue(0);
        break;
      case usersTypes.customers:
        setValue(1);
        break;
      default:
        setValue(0);
        break;
    }
  }
  /**
   *
   * @param event
   * @param newValue
   */
  function handleChangeValue(event: React.SyntheticEvent, newValue: number) {
    switch (newValue) {
      case 0:
        navigate(`${LocalUrlEnum.users}?type=${usersTypes.employees}`);
        break;
      case 1:
        navigate(`${LocalUrlEnum.users}?type=${usersTypes.customers}`);
        break;
      default:
        navigate(`${LocalUrlEnum.users}?type=${usersTypes.employees}`);
        break;
    }
  }

  /**
   *
   */
  function showInformationForTabs() {
    switch (value) {
      case 0:
        return <Users type={usersTypes.employees} />;
      case 1:
        return <Users type={usersTypes.customers} />;
      default:
        return <Users type={usersTypes.customers} />;
    }
  }

  /**
   *
   * @param tabValue
   * @returns
   */
  function getTabStyle(tabValue: number) {
    return {
      backgroundColor:
        value === tabValue
          ? theme.palette.primary.main
          : theme.palette.grayColor?.main,
      color: value === tabValue ? "white" : "#9c9b9b",
      borderTopRightRadius: "10px",
      borderTopLeftRadius: "10px",
      marginRight: "1px",
    };
  }
  return (
    <>
      <Tabs
        value={value}
        onChange={handleChangeValue}
        TabIndicatorProps={{
          style: {
            backgroundColor: theme.palette.primary.main,
          },
        }}
      >
        <Tab label={Vocabulary.employees} style={getTabStyle(0)} />
        <Tab label={Vocabulary.customers} style={getTabStyle(1)} />
      </Tabs>
      <> {showInformationForTabs()}</>
    </>
  );
}
